"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Leaf } from "lucide-react";
export default function OurBlogAndInsights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="our-blog-and-insights" className="relative py-24 lg:py-32 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-primary)/0.05,transparent_40%)] pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,var(--color-secondary)/0.03,transparent_40%)] pointer-events-none" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none [mask-image:radial-gradient(ellipse_at_center,black,transparent_80%)]">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-lg bg-primary/10 text-primary text-sm font-medium mb-8 border border-primary/20">
            <Leaf className="w-4 h-4" />
            <span className="uppercase tracking-wider">Knowledge Base</span>
          </div>

          {}
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold font-default tracking-tight text-foreground mb-8 leading-[1.1]">
            Our Blog & <span className="text-primary">Insights</span>
          </h1>

          {}
          <div className="relative">
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
              Discover expert landscape design tips, industry updates, and inspiration to transform your outdoor spaces into breathtaking havens.
            </p>
            
            {}
            <div className="mt-12 flex justify-center items-center gap-4">
              <div className="h-px w-12 bg-border" />
              <div className="w-2 h-2 rounded-lg bg-primary/40" />
              <div className="h-px w-12 bg-border" />
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute top-1/4 -left-12 w-64 h-64 bg-primary/5 rounded-lg blur-3xl -z-10 animate-pulse" />
      <div className="absolute bottom-1/4 -right-12 w-64 h-64 bg-secondary/5 rounded-lg blur-3xl -z-10 animate-pulse" style={{
      animationDelay: '1s'
    }} />
    </section>;
}